export default __webpack_public_path__ + "static/media/appsignal.24e95949.svg";